define('models/queueAdmin/WrapupCode',[
    'lib/knockout',
    'util/ObservableModel',
    //no references
    'extensions/knockout.validation.extender'
], function (ko, ObservableModel) {
    'use strict';

    return ObservableModel.extend({
        defaults: {
            name: ''
        }
    }, function () {
        var self = this;

        self.name.extend({
            required: true,
            minLength: 1,
            maxLength: 64
        });

        self.unwrap = function () {
            return ObservableModel.unwrap(self, [
                "errors",
                "isAnyMessageShown",
                "isValid",
                "unwrap"
            ]);
        };
    });
});
